<form [formGroup]="deliveryDateForm"
      #form="ngForm">
  <div class="delivery-date-time-title"
       mat-dialog-title>{{ "CART.DELIVERY_DATE_TIME_TITLE" | transloco }}</div>
  <div mat-dialog-content>
    <mat-button-toggle-group class="delivery-date-time-dayselector"
                             name="fontStyle"
                             aria-label="Font Style"
                             [value]="selectedDay"
                             (change)="onSelectDay($event)">
      @for (pickupDay of pickupDays; track pickupDay) {
      <mat-button-toggle [value]="pickupDay.day">
        <!-- <ng-container *ngFor="let dayDiffCount of [dayDiff(currentDate, pickupDay.day)]">
          <span *ngIf="dayDiffCount === 0"
          class="delivery-date-time-dayselector-day">{{ "COMMON.TODAY" | transloco }}</span>
          <span *ngIf="dayDiffCount > 0 && dayDiffCount <=2"
          class="delivery-date-time-dayselector-day">{{ pickupDay.day | translocoDate: { weekday: "long" } }}</span>
          <span *ngIf="dayDiffCount >2"
          class="delivery-date-time-dayselector-day">{{ pickupDay.day | translocoDate: { dateStyle: 'full' } }}</span>
        </ng-container> -->
        @for (dayDiffCount of [dayDiff(currentDate, pickupDay.day)]; track dayDiffCount) {
        @if (dayDiffCount === 0) {
        <span class="delivery-date-time-dayselector-day">{{ "COMMON.TODAY" | transloco }}</span>
        } @else {
        <span class="delivery-date-time-dayselector-day">{{ pickupDay.day | translocoDate: dateFormatOptions }}</span>
        }
        }
      </mat-button-toggle>
      }
    </mat-button-toggle-group>
    <mat-form-field class="delivery-date-time-timeselector">
      <mat-label>{{ "CART.DELIVERY_HOUR" | transloco }}</mat-label>
      <mat-select [value]="selectedDate"
                  formControlName="deliveryDate"
                  (selectionChange)="onSelectTime($event)"
                  [compareWith]="compareDates">
        @for (heure of heuresRetrait; track heure) {
        <mat-option [value]="heure">{{ heure | translocoDate: { timeStyle: 'short' } }}</mat-option>
        }
      </mat-select>
      <mat-icon matSuffix
                class="select-arrow-icon">keyboard_arrow_down</mat-icon>
      @if (deliveryDateForm.get('deliveryDate').hasError('required')) {
      <mat-error>
        {{ 'COMMON.ERRORS.FIELD_REQUIRED_FORMAT' | transloco : { field: 'CART.DELIVERY_HOUR' | transloco } }}
      </mat-error>
      }
    </mat-form-field>
  </div>
  <div mat-dialog-actions
       class="flex-row justify-center align-center">
    <button class="confirm-button"
            mat-button
            (click)="onValueChanges()"
            mat-flat-button
            color="accent">
      {{ "COMMON.CONFIRM" | transloco }}
    </button>
  </div>
</form>
